import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Fade from "@mui/material/Fade";
import {
  Box,
  DialogActions,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import { getSx } from "../../../components/Modal/style";
import CustomTextField from "../../../components/Textfield";
import Button from "../../../components/Button";
import { getVerifyEmailOtp, verifyOtp } from "../../../http/auth";
import { useDispatch } from "react-redux";
import { showToast } from "../../../store/slices/common";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Fade ref={ref} {...props} />;
});

const CustomDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": {
    width: "400px",
    padding: "30px",
    borderRadius: "20px",
  },
  "& .MuiPaper-root": { maxWidth: "400px" },
  "& .MuiDialogActions-root": {},
}));

export default function VerifyEmail({ open, setOpen, email, verifiedHandler }) {
  const [otp, setOtp] = useState("");
  const [resendTimer, setResendTimer] = React.useState(0);
  const classes = getSx(true);
  const dispatch = useDispatch();

  useEffect(() => {
    runTimer();
  }, []);

  useEffect(() => {
    if (!open) {
      setOtp("");
    }
  }, [open]);

  const getOtpHandler = async () => {
    try {
      const res = await getVerifyEmailOtp({ email: email });
      if (res.status == 200) {
        dispatch(showToast({ color: "success", msg: res.data.message?.en }));
        runTimer();
      }
    } catch (err) {
      dispatch(
        showToast({ color: "error", msg: err.response.data.message?.en })
      );
    }
  };

  const runTimer = () => {
    setResendTimer(60);
    const timer = setInterval(() => {
      setResendTimer((prev) => {
        if (prev === 1) clearInterval(timer);
        return prev - 1;
      });
    }, 1000);
  };

  const verifyHandler = async () => {
    try {
      const res = await verifyOtp({ email: email, otp: Number(otp) });
      if (res.status == 200) {
        dispatch(showToast({ color: "success", msg: res?.data?.message }));
        verifiedHandler();
        closeModalHandler();
      }
    } catch (err) {
      dispatch(
        showToast({ color: "error", msg: err?.response?.data?.message })
      );
      setOtp("");
    }
  };

  const handleChange = (e) => {
    setOtp(e.target.value);
  };

  const closeModalHandler = () => setOpen(false);

  return (
    <CustomDialog
      open={open}
      keepMounted
      onClose={() => setOpen(false)}
      TransitionComponent={Transition}
      sx={{ "& .MuiPaper-root": { maxWidth: "400px" } }}
    >
      <DialogContent sx={{ padding: "8px 20px" }}>
        <Box sx={{ ...classes.subTitleContainer, gap: "1rem" }}>
          <Box>
            <Typography
              sx={{
                fontSize: "20px",
                minWidth: "300px",
                maxWidth: "400px",
                textAlign: "center",
                marginBottom: "10px",
              }}
            >
              Verify Email
            </Typography>
          </Box>
        </Box>
        <>
          <TextField
            margin="normal"
            required
            fullWidth
            id="otp"
            label="OTP"
            name="otp"
            autoComplete="off"
            autoFocus
            value={otp}
            onChange={handleChange}
            sx={{
              "& input": {
                fontSize: "18px",
                padding: "14px",
                color: "#343434",
              },
              "& .MuiFormLabel-root.Mui-focused": { color: "#0832DE" },
              "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0832DE !important",
              },
            }}
          />

          <Button
            onClick={getOtpHandler}
            fullWidth
            variant="text"
            disabled={resendTimer > 0}
            sx={{
              mt: 1,
              color: resendTimer > 0 ? "#ccc" : "#0832DE",
              "&:hover": { background: "transparent" },
            }}
          >
            Resend OTP {resendTimer > 0 && `(${resendTimer}s)`}
          </Button>
        </>
      </DialogContent>
      <DialogActions
        disableSpacing={false}
        sx={{ ...classes.buttonWrapper, justifyContent: "center" }}
      >
        <Button
          style={{ ...classes.button }}
          disabled={otp.length !== 4}
          label="Verify"
          onClick={verifyHandler}
        />
      </DialogActions>
      <Typography
        sx={{
          color: "#67697A",
          fontSize: "14px",
          width: "100%",
          fontWeight: "500",
          textAlign: "center",
        }}
      >
        Back to{" "}
        <span
          style={{ color: "#0832DE", cursor: "pointer", fontWeight: "600" }}
          onClick={closeModalHandler}
        >
          Profile
        </span>
      </Typography>
    </CustomDialog>
  );
}
